<template>
  <modal
    :title="
      'Match Departure City (' +
        setModel.Name +
        ' - ' +
        setModel.OperatorName +
        ')'
    "
    :size="'md'"
    @close="$emit('close')"
  >
    <template #content>
      <loadArea v-if="cities == null"></loadArea>
      <Form
        method="dialog"
        v-slot="{ errors }"
        v-if="cities != null"
        class="floating-labels p-1rem row"
        ref="form"
      >
        <div class="col-md-12">
          <selectBox
            :title="'DepartureCityId'"
            :as="'select'"
            :disabled="cities.length == 0"
            :buttons="true"
            v-model="model.DepartureCityId"
            :errors="errors"
            @keydown.enter="save"
          >
            <template #search>
              <input
                type="text"
                placeholder="Ara"
                class="form-control small"
                v-model="searchCountry"
              />
            </template>
            <template #input>
              <option :value="null"></option>
              <template v-for="item in cities">
                <option
                  :value="item.Id"
                  v-if="
                    item.Name.toUpperCase().indexOf(
                      searchCountry.toUpperCase()
                    ) > -1
                  "
                  :key="item.Code"
                  >{{ item.Name }}</option
                >
              </template>
            </template>
            <template #buttons>
              <button
                type="button"
                @click="addDepartureCitiesOpen = true"
                class="btn waves-effect waves-light btn-success"
              >
                <i class="fas fa-plus"></i>
              </button>
            </template>
          </selectBox>
        </div>
        <div class="col-md-12">
          <formGroup
            :title="'Name'"
            v-model="model.Name"
            :errors="errors"
            :rules="{ required: true, max: 255 }"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-md-6">
          <formGroup
            :title="'Code1'"
            v-model="model.Code1"
            :errors="errors"
            :rules="{ max: 50 }"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-md-6">
          <formGroup
            :title="'Code2'"
            v-model="model.Code2"
            :errors="errors"
            :rules="{ max: 50 }"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-md-6">
          <formGroup
            :title="'Code3'"
            v-model="model.Code3"
            :errors="errors"
            :rules="{ max: 50 }"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-md-6">
          <formGroup
            :title="'Code4'"
            v-model="model.Code4"
            :errors="errors"
            :rules="{ max: 50 }"
            @keydown.enter="save"
          ></formGroup>
        </div>
      </Form>
    </template>
    <template #foot>
      <Btn
        class="btn-success btn-md"
        @click="save"
        :disabled="cities == null"
        :process="process"
        >{{ "Match Departure City" }}</Btn
      >
    </template>
  </modal>
  <addDepartureCities
    v-if="addDepartureCitiesOpen"
    @close="addDepartureCitiesOpen = false"
    @add="cities.push({ Id: $event.Id, Name: $event.Name })"
  ></addDepartureCities>
</template>

<script>
import addDepartureCities from "@/views/tourscope/departureCities/upsert";
import selectBox from "@/components/formGroup/selectBox";
export default {
  props: {
    setModel: Object,
    operators: Array,
  },
  components: { addDepartureCities, selectBox },
  data() {
    return {
      model: {
        Id: this.setModel.Id,
        OperatorId: this.setModel.OperatorId,
        DepartureCityId: this.setModel.DepartureCityId,
        Name: null,
        Code1: null,
        Code2: null,
        Code3: null,
        Code4: null,
      },
      searchCountry: "",
      process: false,
      cities: null,
      addDepartureCitiesOpen: false,
    };
  },
  watch: {
    // selectCountry(){
    //     this.model.CountryId=this.selectCountry.Id;
    //     this.model.Code1=this.selectCountry.ISO2;
    //     this.model.Code2=this.selectCountry.ISO3;
    //     this.model.Code3=this.selectCountry.CurrencyCode;
    // }
  },
  created() {
    if (this.setModel != undefined) {
      this.model.Id = this.setModel.Id;
      this.model.OperatorId = this.setModel.OperatorId;
      this.model.Code1 = this.setModel.Code1;
      this.model.Code2 = this.setModel.Code2;
      this.model.Code3 = this.setModel.Code3;
      this.model.Name = this.setModel.Name;
      this.model.CountryId = this.setModel.Id1;
    }
    this.$appAxiosAdmin
      .get(`tourscope/DepartureCitiesNames`)
      .then((response) => {
        this.cities = response.data;
      });
  },
  methods: {
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.process = true;
          this.$appAxiosAdmin
            .put(`TOURSCOPE/OperatorDepartureCities`, this.model)
            .then((response) => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text: "Departure cities successfully matched",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              this.$emit("match", response.data);
              this.$emit("close");
            })
            .catch((err) => {
              this.process = false;
              this.$swal({
                icon: "error",
                title: "Error",
                text: err.response.data.title,
                timer: 2000,
                confirmButtonText: "Okey",
              });
            });
        }
      });
    },
  },
};
</script>

<style></style>
